import Fetch, { serializeQueryString } from 'Util/fetcher';
import { errorLogger } from '@ajaibid/utils';
import { DEFAULT_GET_RESPONSE } from '@config/constanta';
import {
  dtSysParamUrl,
  dtMultiplierListUrl,
  dtMultiplierByCodeUrl,
  dtEnabledByStockCodeUrl,
} from './_endpoint';

const fetchGet = (url, { query } = {}) =>
  Fetch.get(`${url}${serializeQueryString(query)}`)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: url });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });

// DT global config
export const getDtParamActivation = () => fetchGet(dtSysParamUrl('ODT_PANIC_ACTIVATION'));
export const getDtParamCashTransfer = () => fetchGet(dtSysParamUrl('ODT_PANIC_CASH_TRANSFER'));
export const getDtParamBuySell = () => fetchGet(dtSysParamUrl('ODT_PANIC_BUY_SELL'));

// DT stock config
export const getDtMultiplierList = () => fetchGet(dtMultiplierListUrl);
export const getDtMultiplierByCode = (code) => fetchGet(dtMultiplierByCodeUrl(code));

export const getCheckStockDtEnabled = (code) => fetchGet(dtEnabledByStockCodeUrl(code));
